import { enderecoController } from './../../controllers/comum/enderecoController';
import microuniversoApi from "app/api/microuniversoApi"
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"


import globalMU from "globalMU"
import {IOrcamento} from "../../types/IOrcamento";
import {Obra} from "../../types/Obra";


declare var window:any

export type AlterarPrecoItemParams = {
    obra: Obra
}

export async function alterarObra(params:AlterarPrecoItemParams) {
    try {
        globalMU.blockUI({tryPassiveLoading: true})

        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirObra(
            store.getState().orcamento.IdentificadorOrcamento,
            params.obra?.IdObra ?? 0
            )

        const atualizarOrcamentoLegado = () => {
            const orcamentoLegado = window.orcamentoController.model
            orcamentoLegado.atualizar(
                orcamentoAtualizado,
                true,
                false)

            store.dispatch(sobrescreverInformacoesAction(orcamentoAtualizado))


        }

        atualizarOrcamentoLegado()
    } finally {
        globalMU.unblockUI()
    }
}
